/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Users_Create_FailedInputs */

const en_users_create_failed = /** @type {(inputs: Users_Create_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to create user: ${i?.message}`)
};

const pt_br2_users_create_failed = /** @type {(inputs: Users_Create_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao criar usuário: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to create user: {message}" |
*
* @param {Users_Create_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_create_failed = /** @type {((inputs: Users_Create_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Create_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_create_failed(inputs)
	return pt_br2_users_create_failed(inputs)
});